'use client';

import { c as _c } from "react/compiler-runtime";
import { useBfcacheRestore } from '@cc-shopping/hooks/useBfcacheRestore';
import clsx from 'clsx';
import { useState } from 'react';
import { SignUpFormSuccessProvider } from 'src/features/travel/TravelNerdBanner/SignUpForm/SignUpFormSuccessContext';
import { FormWithLegals } from './FormWithLegals';
import { ManualCtaVariant } from './PostSignupRedirect/ManualCtaVariant';
function TravelNewsletterContent() {
  const $ = _c(3);
  const [hasSignedUp, setHasSignedUp] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setHasSignedUp(false);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useBfcacheRestore(t0);
  if (!hasSignedUp) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SignUpFormSuccessProvider value={() => setHasSignedUp(true)}><FormWithLegals /></SignUpFormSuccessProvider>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ManualCtaVariant />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function TravelNewsletterExperience() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={clsx("pt-12")}><TravelNewsletterContent /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}